import AuthenticatorApp from './AuthenticatorApp.js';
import BackupCode from './BackupCode.js';
import Email from './Email.js';
import SMS from './SMS.js';
export default {
  install(molten) {
    molten.addPlugin('TwoFactorAuthMethod', AuthenticatorApp);
    molten.addPlugin('TwoFactorAuthMethod', Email);
    molten.addPlugin('TwoFactorAuthMethod', SMS);
    molten.addPlugin('TwoFactorAuthMethod', BackupCode);
  }
};